<template>
  <div class="item">
    <div class="font-bold" v-if="label">
      {{ label }}
    </div>
    <div>{{ modelValue || '-' }}</div>
  </div>
</template>
<script>
export default {
  name: 'TextField',
  props: {
    label: {
      type: String,
      default: ''
    },
    modelValue: String
  },
  emits: ['update:modelValue']
};
</script>
